import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bankcreation',
  templateUrl: './bankcreation.component.html',
  styleUrls: ['./bankcreation.component.css']
})
export class BankcreationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/bankcreation/bankcreation.component.ts